import { isValidIsraeliNationalId } from './bookingPaymentValidate';

export const EMPLOYER_CREDITS_PAYMENT_METHOD = 'employer_credits' as const;

export type WorkerCreditsPaymentInput = {
  nationalId: string;
  businessId: string;
};

export type WorkerCreditsPaymentFieldErrors = {
  nationalId?: string;
  businessId?: string;
};

function digitsOnly(value: string): string {
  return value.replace(/\D+/g, '');
}

/** Israeli company registration (ח.פ.) — digits only, typical length 5–12. */
export function isValidEmployerBusinessId(raw: string): boolean {
  const digits = digitsOnly(raw);
  return digits.length >= 5 && digits.length <= 12;
}

export function workerCreditsPaymentIsValid(errors: WorkerCreditsPaymentFieldErrors): boolean {
  return Object.keys(errors).length === 0;
}

export function validateWorkerCreditsPayment(
  input: WorkerCreditsPaymentInput,
  messages: {
    errorNationalId: string;
    errorBusinessId: string;
  },
): WorkerCreditsPaymentFieldErrors {
  const errors: WorkerCreditsPaymentFieldErrors = {};
  if (!isValidIsraeliNationalId(input.nationalId)) {
    errors.nationalId = messages.errorNationalId;
  }
  if (!isValidEmployerBusinessId(input.businessId)) {
    errors.businessId = messages.errorBusinessId;
  }
  return errors;
}

export function normalizeWorkerCreditsPaymentWire(
  input: WorkerCreditsPaymentInput,
): { payment_method: typeof EMPLOYER_CREDITS_PAYMENT_METHOD; national_id: string; business_id: string } {
  return {
    payment_method: EMPLOYER_CREDITS_PAYMENT_METHOD,
    national_id: digitsOnly(input.nationalId).slice(0, 9),
    business_id: digitsOnly(input.businessId).slice(0, 12),
  };
}
